import { supportsNonCryptoServices } from './whitelabel';

export const ROUTE_DASHBOARD = '/my-portfolio';
export const ROUTE_DASHBOARD_EDIT_INVESTMENT = '/my-portfolio/edit/:serviceId';
export const ROUTE_PROFIT_SHARING = '/profit-sharing';
export const ROUTE_MARKETPLACE_Z_INDEXES = '/marketplace';
export const ROUTE_PROFIT_SHARING_RWA = '/profit-sharing-rwa';
export const ROUTE_BECOME_TRADER = '/become-trader';
export const ROUTE_LOGIN = '/login';
export const ROUTE_KYC_LANDING = '/v/e16-1';
export const ROUTE_MOBILE_LANDING = '/new-user-landing';
export const ROUTE_SIGNUP = '/signup';
export const ROUTE_FORGOT_PASSWORD = '/forgot-password';
export const ROUTE_RESET_PASSWORD = '/reset-password/:token';
export const ROUTE_SUBSCRIPTIONS = '/subscriptions';
export const ROUTE_TRADING_SERVICE = '/profit-sharing/:serviceId';
export const ROUTE_PROFIT_SHARING_SERVICE_INVEST =
  '/profit-sharing/:serviceId/invest';
export const ROUTE_TRADING_SERVICE_MANAGE =
  ROUTE_TRADING_SERVICE + '/management';
export const ROUTE_TRADING_SERVICE_INVESTORS =
  ROUTE_TRADING_SERVICE + '/investors';
export const ROUTE_TRADING_SERVICE_POSITIONS =
  ROUTE_TRADING_SERVICE + '/positions';
export const ROUTE_TRADING_SERVICE_COINS = ROUTE_TRADING_SERVICE + '/coins';
export const ROUTE_TRADING_SERVICE_API = ROUTE_TRADING_SERVICE + '/api';
export const ROUTE_TRADING_SERVICE_SIGNALS = ROUTE_TRADING_SERVICE + '/signals';
export const ROUTE_TRADING_SERVICE_MANUAL = ROUTE_TRADING_SERVICE + '/manual';
export const ROUTE_TRADING_SERVICE_EDIT = ROUTE_TRADING_SERVICE + '/edit';
export const ROUTE_MY_BALANCES = '/my-balances';
export const ROUTE_KYC = '/settings/kyc'; // KYC? more like KFC
export const ROUTE_EDIT_PROFILE = '/settings/profile';
export const ROUTE_PASSWORD = '/settings/password';
export const ROUTE_2FA = '/settings/2fa';
export const ROUTE_MY_BALANCES_TRANSACTIONS = '/my-balances/transactions';
export const ROUTE_MY_BALANCES_DEPOSIT_COIN =
  '/my-balances/deposit/:selectedCoin';
export const ROUTE_MY_BALANCES_DEPOSIT = '/my-balances/deposit';
export const ROUTE_REFERRALS = '/referrals';
export const ROUTE_REFERRALS_INVITE = '/invite/:key';
export const ROUTE_REFERRALS_INVITE_SHORT = '/inv/:key';
export const ROUTE_HELP_TRADER = '/help/trader';
export const ROUTE_HELP_INVESTOR = '/help/investor';
export const ROUTE_LEGAL_TOS = '/legal/terms-of-service';
export const ROUTE_LEGAL_PRIVACY = '/legal/privacy';
export const ROUTE_404 = '/404';
export const ROUTE_REPORT = '/report/:token';
export const ROUTE_MAINTENANCE = '/maintenance';
export const ROUTE_SIGNUP_LIGHT = '/v/e6-1';

export const ROUTE_MAIN_MARKETPLACE = supportsNonCryptoServices
  ? ROUTE_MARKETPLACE_Z_INDEXES
  : ROUTE_PROFIT_SHARING;
